<template>
  <button
    class="flex cursor-pointer items-center justify-center text-center font-semibold duration-300 disabled:cursor-not-allowed"
    :class="{
      'p-3.5 text-lg': size === 'md',
      '--sm p-2 text-base': size === 'sm',
      'rounded-full': variant === 'rounded-xs',
      'free-button': variant === 'default',
    }"
  >
    <slot />
  </button>
</template>

<script setup lang="ts">
  type ButtonSize = 'sm' | 'md';
  type ButtonVariant = 'default' | 'rounded-xs';

  withDefaults(
    defineProps<{
      size?: ButtonSize;
      variant?: ButtonVariant;
    }>(),
    {
      size: 'md',
      variant: 'default',
    },
  );
</script>

<style scoped>
  .free-button {
    border-radius: var(--free-btn-border-radius, 1rem);
  }

  .free-button:disabled {
    opacity: 0.5;
  }

  .green-main-button:disabled {
    opacity: 1;
  }

  .--sm {
    --free-btn-border-radius: 0.75rem;
  }
</style>
